import { Injectable } from '@angular/core';
import { SidebarDtoV2 } from '@osos/shared/api';

import {
  LinkPresenterModel,
  NavigationPresenterModel,
  NavigationPresenterModelV2,
  PinnedEntities,
} from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class NavigationParserV2Service extends ParserBase<
  SidebarDtoV2,
  NavigationPresenterModelV2
> {
  constructor() {
    super(SidebarDtoV2, NavigationPresenterModelV2, 1);
  }

  getPresenterModel(model: SidebarDtoV2): NavigationPresenterModelV2 {
    // TODO: Use the parsers of module & data-view & generic-view to map to presenter model, before using them.

    const presenter: NavigationPresenterModelV2 = {
      specificationVersion: 2,
      links: this.prepareItems(model.links),
      serviceViewsStatus: {
        onGoingInbox: model?.serviceViewsStatus?.onGoingInbox || 0,
        onGoingRequests: model?.serviceViewsStatus?.onGoingRequests || 0,
        onGoingObserverRequests:
          model?.serviceViewsStatus?.onGoingObserverRequests || 0,
        hasInbox: model?.serviceViewsStatus?.hasInbox || false,
        hasObserverRequests:
          model?.serviceViewsStatus?.hasObserverRequests || false,
        hasRequests: model?.serviceViewsStatus?.hasRequests || false,
        hasServiceCatalog:
          model?.serviceViewsStatus?.hasServiceCatalog || false,
      },
    };
    return presenter;
  }

  getDataModel(presenter: NavigationPresenterModel): SidebarDtoV2 {
    throw new Error('Method not implemented.');
  }

  prepareItems(items: LinkPresenterModel[]): any[] {
    const relatedItems: { [key: string]: LinkPresenterModel[] } = {};
    const viewsItems = items.reduce<LinkPresenterModel[]>((acc, view) => {
      view.type = {
        id: this.getLinkType(view),
      };
      if (view.children?.length) {
        view.children = this.prepareItems(view.children);
      }
      if (view.userCollections?.length > 0) {
        if (view.userCollections?.length > 0) {
          const userCollections =
            this._prepareDataViewUserCollectionItems(view);

          relatedItems[view.id] = userCollections;
        }
      }
      if (view.sharedCollections?.length > 0) {
        const sharedCollections =
          this._prepareDataViewSharedCollectionItems(view);

        if (!relatedItems[view.id]) {
          relatedItems[view.id] = sharedCollections;
        } else {
          relatedItems[view.id] =
            relatedItems[view.id].concat(sharedCollections);
        }
      }
      if (view.userQueries?.length > 0) {
        const userQueries = this._prepareDataViewSavedQueryItems(view);

        if (!relatedItems[view.id]) {
          relatedItems[view.id] = userQueries;
        } else {
          relatedItems[view.id] = relatedItems[view.id].concat(userQueries);
        }
      }

      if (relatedItems[view.id]?.length) {
        view.hasRelatedItems = true;
        relatedItems[view.id][
          relatedItems[view.id].length - 1
        ].isLastRelatedItem = true;
      }

      acc.push(view);

      if (relatedItems[view.id]) {
        acc.push(...relatedItems[view.id]);
      }

      return acc;
    }, []);

    return viewsItems;
  }

  private _prepareDataViewUserCollectionItems(view: LinkPresenterModel) {
    return (
      view.userCollections.map((collectionItem) => {
        return {
          ...this._prepareDataViewCollectionItem(
            view,
            collectionItem,
            PinnedEntities.UserCollections,
          ),
        };
      }) ?? []
    );
  }
  private _prepareDataViewSharedCollectionItems(view: LinkPresenterModel) {
    return (
      view.sharedCollections.map((collectionItem) => {
        return {
          ...this._prepareDataViewCollectionItem(
            view,
            collectionItem,
            PinnedEntities.SharedCollections,
          ),
        };
      }) ?? []
    );
  }
  private _prepareDataViewCollectionItem(
    view: LinkPresenterModel,
    collectionItem: LinkPresenterModel,
    collectionType: PinnedEntities,
  ): LinkPresenterModel {
    const _item = {
      ...collectionItem,
      icon: collectionItem.icon ?? view.icon,
      type: {
        id: collectionType,
      },
    } as LinkPresenterModel;

    return _item;
  }
  private _prepareDataViewSavedQueryItems(view: LinkPresenterModel) {
    return (
      view.userQueries.map((query) => {
        return {
          ...this._prepareDataViewSavedQueryItem(view, query),
        };
      }) ?? []
    );
  }

  private _prepareDataViewSavedQueryItem(
    view: LinkPresenterModel,
    savedQueryItem: any,
  ): LinkPresenterModel {
    const _item = {
      ...savedQueryItem,
      icon: view.icon,
      type: {
        id: PinnedEntities.UserQueries,
      },
    } as LinkPresenterModel;

    return _item;
  }

  private getLinkType(item: LinkPresenterModel) {
    switch (item.type.id) {
      case '0':
        return PinnedEntities.Module;
      case '1':
        return PinnedEntities.DataViews;
      case '2':
        return PinnedEntities.GenericView;
      case '3':
        return PinnedEntities.Reports;
      case '4':
        return PinnedEntities.UnTyped;
    }
    return undefined;
  }
}
